import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { setCurrency } from "@/lib/format";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState(null);
  const [wallet, setWallet] = useState(null);

  const refreshWallet = useCallback(async () => {
    try {
      const { data } = await api.get("/wallet");
      setWallet(data);
    } catch (e) {
      setWallet(null);
    }
  }, []);

  const loadConfig = useCallback(async () => {
    const { data } = await api.get("/config");
    setCurrency(data.currency);
    setConfig(data);
  }, []);

  useEffect(() => {
    loadConfig().catch(() => setConfig({}));
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, [loadConfig]);

  useEffect(() => {
    if (user) refreshWallet();
  }, [user, refreshWallet]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setWallet(null);
  };

  const reloadUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, config, loadConfig, wallet, refreshWallet, logout, reloadUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
